export default __webpack_public_path__ + "static/media/ic_danger_alert_primary.dbc051e9.svg";